export const selectWhatsNewItems = (state) => state.whatsNew.items
export const selectWhatsNewRecent = (state) => state.whatsNew.recent
export const selectWhatsNewStatus = (state) => state.whatsNew.status
export const selectWhatsNewLoading = (state) => state.whatsNew.loading
